<template>
  <div class="main">
    <Header
      :show="true"
      title="水份检测"
      left="prepage"
      right=""
      :click-left="handleClickLeft"
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh;">
      <van-cell :value="listQuery.date.range" is-link @click="listQuery.date.show = true">
        <template #title>
          <span style="font-size: 2vh;">时间区间</span>
        </template>
      </van-cell>
      <van-calendar
        v-model="listQuery.date.show"
        type="range"
        :max-range="366"
        :min-date="listQuery.date.min"
        :max-date="listQuery.date.max"
        :default-date="listQuery.date.default"
        color="#ee0a24"
        :style="{ 'padding-bottom': '30px' }"
        @confirm="onConfirmDateChoose"
      />
      <van-cell :value="listQuery.status.name" is-link @click="listQuery.status.show = true">
        <template #title>
          <span style="font-size: 2vh;">检测状态</span>
        </template>
      </van-cell>
      <van-action-sheet
        v-model="listQuery.status.show"
        :actions="listQuery.status.actions"
        cancel-text="取消"
        description="请选择待查询的检测状态"
        @select="onSelectStatusChoose"
      />
      <div style="margin: 16px;">
        <van-button round block type="info" @click="handleClickQuery">
          查询
        </van-button>
      </div>

      <el-table
        ref="table"
        :data="table.data"
        :row-key="handleRowKey"
        :expand-row-keys="expandRowKeys"
        :row-class-name="handleRowClassName"
        :cell-style="handleCellStyle"
        @row-click="handleTableRowClick"
        style="width: 100%"
      >
        <el-table-column type="expand" width="30px">
          <template slot-scope="{row}">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label="序号">
                <span>{{ row.id }}</span>
              </el-form-item>
              <el-form-item label="流水号">
                <span>{{ row.serial }}</span>
              </el-form-item>
              <el-form-item label="车牌号">
                <span>{{ row.plateNumber }}</span>
              </el-form-item>
              <el-form-item label="司机">
                <span>{{ row.driver }}</span>
              </el-form-item>
              <el-form-item label="物料">
                <span>{{ row.material }}</span>
              </el-form-item>
              <el-form-item label="供应商">
                <span>{{ row.supplier }}</span>
              </el-form-item>
              <el-form-item label="毛重">
                <span>{{ row.grossWeight }}吨</span>
              </el-form-item>
              <el-form-item label="毛重时间">
                <span>{{ row.grossTime }}</span>
              </el-form-item>
              <el-form-item label="识别照片">
                <van-image
                  width="166px"
                  height="100px"
                  :src="row.identifyUrl"
                  @click="handleClickPreview(row.identifyUrl)"
                >
                  <template v-slot:index>识别照片</template>
                </van-image>
              </el-form-item>
              <el-form-item label="识别物料">
                <template #default>
                  <el-tag v-if="row.material.indexOf(row.identifyName) > -1" type="success">{{ row.identifyName }}</el-tag>
                  <el-tag v-else type="warning">{{ row.identifyName }}</el-tag>
                </template>
              </el-form-item>
              <el-form-item label="识别结果">
                <template #default>
                  <el-tag v-if="row.material.indexOf(row.identifyName) > -1" type="success">已放行</el-tag>
                  <!-- <el-button v-else size="mini" type="warning">质检员确认</el-button> -->
                  <span v-else style="color: #F56C6C;">与预约物料不一致，请检测后放行</span>
                </template>
              </el-form-item>
              <el-form-item label="含水量">
                <span>{{ row.waterPercent }}%</span>
              </el-form-item>
              <el-form-item label="品质">
                <span>{{ row.quality }}级</span>
              </el-form-item>
              <el-form-item label="检测照片">
                <van-image
                  width="100px"
                  height="100px"
                  :src="row.qcPhotoUrl"
                  @click="handleClickPreview(row.qcPhotoUrl)"
                >
                  <template v-slot:index>检测照片</template>
                </van-image>
              </el-form-item>
              <!-- <el-form-item label="检测照片">
                <el-button v-if="row.qcPhotoUrl !== ''" type="text" @click="qcPhotoShow = true">附件</el-button>
                <el-button v-else type="text" disabled>无附件</el-button>
              </el-form-item>
              <van-image-preview
                v-model="qcPhotoShow"
                :images="row.qcPhotoList"
              >
                <template v-slot:index>检测照片</template>
              </van-image-preview> -->
              <el-form-item label="备注">
                <span>{{ row.remark }}</span>
              </el-form-item>
              <el-form-item label="状态">
                <el-tag v-if="row.status === '待检测'" type="warning">待检测</el-tag>
                <el-tag v-else-if="row.status === '已退货'" type="danger">已退货</el-tag>
                <el-tag v-else-if="row.status === '已检测'" type="success">已检测</el-tag>
                <el-tag v-else-if="row.status === '已过期'" type="info">已检测</el-tag>
                <el-tag v-else type="primary">未知</el-tag>
              </el-form-item>
              <el-form-item label="质检员">
                <span>{{row.qcMan }}</span>
              </el-form-item>
              <el-form-item label="质检时间">
                <span>{{row.qcTime }}</span>
              </el-form-item>
              <el-form-item label="操作" v-if="checkPermission([22])">
                <el-button v-if="row.status === '待检测'" type="primary" size="mini" @click="handleClickUpdate(row)">
                  检测
                </el-button>
                <el-button v-else type="info" size="mini" disabled>
                  检测
                </el-button>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column label="序号" prop="id" align="center" width="40">
          <template slot-scope="{row}">
            <span>{{ row.id }}</span>
          </template>
        </el-table-column>
        <el-table-column label="车牌号" prop="plateNumber" align="center" min-width="80" show-overflow-tooltip>
          <template slot-scope="{row}">
            {{ row.plateNumber }}
          </template>
        </el-table-column>
        <el-table-column label="物料名称" prop="material" align="center" show-overflow-tooltip>
          <template slot-scope="{row}">
            {{ row.material }}
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="status" align="center" width="90">
          <template slot-scope="{row}">
            <el-tag v-if="row.status === '待检测'" type="warning">待检测</el-tag>
            <el-tag v-else-if="row.status === '已退货'" type="danger">已退货</el-tag>
            <el-tag v-else-if="row.status === '已检测'" type="success">已检测</el-tag>
            <el-tag v-else-if="row.status === '已过期'" type="info">已过期</el-tag>
            <el-tag v-else type="primary">未知</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-show="table.total>0"
        :total="table.total"
        background
        layout="prev, pager, next"
        :current-page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        :pager-count="table.fullWidth>380?5:3"
        style="margin: .6rem 0; text-align: center;"
        @current-change="handleClickQuery"
      />
      <div style="height: 1rem; background-color: #FFFFFF;" />
    </div>
    <Footer value="service" />
  </div>
</template>

<script>
  import { Dialog, ImagePreview } from 'vant'
  import { showPhoneAlarm } from '@/global/function.js'
  import { parseTime } from '@/utils'
  import checkPermission from '@/utils/permission'
  import Header from '@/views/components/header/index.vue'
  import Footer from '@/views/components/footer/index.vue'
  import { getList } from '@/api/water.js'

  export default {
    name: "ServiceBussinessWater",
    components: {
      Header,
      Footer
    },
    inject: ['reload'],
    data() {
      const EDate = parseTime(new Date(), '{y}/{m}/{d}')
      const dayTimeStamp = (new Date(EDate)).getTime()
      const beforeTimeStamp = dayTimeStamp - 7*24*3600*1000
      const SDate = parseTime(beforeTimeStamp, '{y}/{m}/{d}')
      return {
        listQuery: {
          limit: 10,
          page: 1,
          date: {
            show: false,
            min: new Date(2020, 1, 1),
            max: new Date(2030, 12, 31),
            range: SDate + ' - ' + EDate,
            start: beforeTimeStamp,
            end: dayTimeStamp,
            default: [new Date(SDate), new Date(EDate)]
          },
          type: {
            show: false,
            actions: [
              { name: '全部', value: 9, subname: '' },
              { name: '骨料', value: 1 },
              { name: '粉料', value: 2 },
              { name: '其他', value: 3 }
            ],
            name: '骨料',
            value: 1
          },
          plateNumber: '',
          status: {
            show: false,
            actions: [
              { name: '全部', value: 9, subname: '' },
              { name: '待检测', value: 0 },
              { name: '正常', value: 1 },
              { name: '退货', value: 2 }
            ],
            name: '全部',
            value: 9
          },
          verify: 1,
          reason: null
        },
        qcPhotoShow: false,
        baseUrl: '',
        isLoading: false,
        table: {
          listLoading: false,
          fullWidth: document.documentElement.clientWidth,
          key: 0,
          total: 0,
          data: []
        },
        expandRowKeys: [],
        handleRowKey(row) {
          return row.id
        }
      }
    },
    computed: {

    },
    watch: {

    },
    beforeCreate() {

    },
    created() {
      const url = window.location.href
      this.baseUrl = url.substr(0, url.indexOf('/ndwnq')) + '/ndwnq'
      this.handleClickQuery()
    },
    beforeMount() {

    },
    mounted() {

    },
    beforeUpdate() {

    },
    updated() {

    },
    beforeDestroy() {

    },
    destroyed() {

    },
    methods: {
      checkPermission,
      handleClickLeft() {
        this.$router.go(-1)
        // console.log('dashboard-left')
      },
      handleClickRight() {
        this.$router.push({
          path:'/service/system/staff/create',
          query: {} ,
        })
      },
      handleTableRowClick(row, column, event) {
        this.$refs.table.toggleRowExpansion(row)
      },
      handleRowClassName({row, rowIndex}) {
        if (row.material.indexOf(row.identifyName) > -1) {
          return 'normal-row'
        }
        return 'fault-row'
      },
      handleCellStyle({ row, column, rowIndex, columnIndex }) {
        return ''
      },
      formatDate(date) {
        const year = date.getFullYear()
        const month = date.getMonth()
        const day = date.getDate()
        return `${year}/${(month + 1) >9 ? (month + 1) : '0'+(month + 1)}/${day > 9 ? day : '0'+day}`
      },
      onConfirmDateChoose(date) {
        const [start, end] = date
        this.listQuery.date.show = false
        this.listQuery.date.range = `${this.formatDate(start)} - ${this.formatDate(end)}`
        this.listQuery.date.start = (new Date(start)).getTime()
        this.listQuery.date.end = (new Date(end)).getTime()
      },
      onSelectStatusChoose(item) {
        this.listQuery.status.show = false
        this.listQuery.status.id = this.listQuery.status.actions.indexOf(item)
        this.listQuery.status.name = item.name
        this.listQuery.status.value = item.value
      },
      onRefresh() {
        setTimeout(() => {
          this.isLoading = false
          this.listQuery.page++
          if (this.listQuery.limit * (this.listQuery.page + 1) < this.table.total) {
            this.handleClickQuery()
          } else {
            showPhoneAlarm(true, 'toast', null, 2000, null, '拉取水份检测记录', '没有新的数据')
          }
        }, 1000)
      },
      handleClickPreview(url) {
        console.log(url)
        let urlArr = []
        urlArr.push(url)
        ImagePreview(urlArr);
      },
      handleClickQuery() {
        const data = {
          page: this.listQuery.page,
          limit: this.listQuery.limit,
          startDate: this.listQuery.date.start,
          endDate: this.listQuery.date.end,
          plateNumber: this.listQuery.plateNumber,
          type: 1, //骨料
          status: this.listQuery.status.value
        }
        getList(data).then(response => {
          const { data } = response
          if (showPhoneAlarm(false, 'toast', null, 2000, data.code, null, data.message)) {
            this.table.total = data.data.total
            const items = data.data.items
            this.table.data = []
            for (let i=0; i<items.length; i++) {
              let status = '未知'
              if (items[i].status === 0) {
                if ((items[i].tareTime !== '') && (items[i].tareTime !== null)) {
                  status = '已过期'
                } else {
                  status = '待检测'
                }
              } else if (items[i].status === 1) {
                status = '已检测'
              } else if (items[i].status === 2) {
                status = '已退货'
              }
              let url = this.baseUrl + items[i].qcPhotoUrl
              this.table.data.push({
                id: this.listQuery.limit * (this.listQuery.page - 1) + i + 1,
                serial: items[i].id,
                plateNumber: items[i].plateNumber,
                driver: items[i].driver,
                material: items[i].materialName,
                supplier: items[i].supplier,
                grossWeight: items[i].grossWeight,
                grossTime: parseTime(items[i].grossTime, '{y}-{m}-{d} {h}:{i}:{s}'),
                waterPercent: items[i].waterPercent,
                identifyName: items[i].identifyName,
                identifyUrl: this.baseUrl + items[i].identifyUrl,
                AIMaterial: items[i].identifyName,
                AIMaterialUrl: this.baseUrl + items[i].identifyUrl,
                quality: items[i].quality,
                qcPhotoUrl: url,
                qcPhotoList: url.split('----'),
                remark: items[i].remark,
                status: status,
                qcMan: items[i].qcMan,
                qcTime: parseTime(items[i].qcTime, '{y}-{m}-{d} {h}:{i}:{s}')
              })
            }
          }
        }).catch(function(error) {
          console.error(error)
        })
      },
      handleClickUpdate(row) {
        this.$router.push({
          path:'/service/business/water/create',
          query: row
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  // 系统样式修改
  ::v-deep .el-form-item__label {
    width: 20%;
    text-align: right;
    // margin-right: 20px;
  }
  ::v-deep .el-table__expanded-cell[class*=cell] {
    padding: 20px 10px;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 100%;
  }
  ::v-deep .van-cell__title {
    max-width: 30%;
  }
  ::v-deep .van-cell__value {
    max-width: 70%;
  }
  ::v-deep .el-table th>.cell {
    padding-left: 5px;
    padding-right: 5px;
  }
  ::v-deep .el-table td>.cell {
    padding-left: 5px;
    padding-right: 5px;
  }
  // 自定义样式
  .main {
    height: 100vh;
    font-size: 2vw;
    background-color: #FFFFFF;//#F7F8FA;
    overflow-x: hidden;
    // overflow-y:hidden;
    overflow-y: auto;
    // display: flex;
    // justify-content: center;
    // align-items: center;
  }
  ::v-deep .el-table .fault-row {
    background: #FDE2E2;
    // background: #feebe9;
  }
</style>
